import { render, staticRenderFns } from "./SearchSettingsEdit.vue?vue&type=template&id=03d5e7f0"
import script from "./SearchSettingsEdit.vue?vue&type=script&lang=ts"
export * from "./SearchSettingsEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d5e7f0')) {
      api.createRecord('03d5e7f0', component.options)
    } else {
      api.reload('03d5e7f0', component.options)
    }
    module.hot.accept("./SearchSettingsEdit.vue?vue&type=template&id=03d5e7f0", function () {
      api.rerender('03d5e7f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/browse/SearchSettingsEdit.vue"
export default component.exports